<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_xviii"></a><a id="page_xix"></a><a id="ack"></a>ACKNOWLEDGMENTS</h2>
<h4 class="h4a">JAY CONRAD LEVINSON</h4>
<p class="indent">I owe heartfelt acknowledgement in this book to Andrew Neitlich, who did all the heavy lifting and supplied the brilliance with which this book has been written. If you benefit from his insight, give all the credit to him, for I was merely along for the ride. My main contribution has been to provide the guerrilla spirit that has infused him. He has done a wonderful job absorbing it and spreading it to everyone who reads the words he has written.</p>
<h4 class="h4a">ANDREW NEITLICH</h4>
<p class="indent">I am forever grateful to Jim Reilly, who was generous enough to introduce me to Jay Conrad Levinson. Jay has been a hero of mine for decades, and it is an honor and a highlight of my career to have this opportunity to work with him. John Lankford and Corey Crowder deserve special acknowledgement, too. Our work together creating career transition programs for elite athletes started me down the road that led to this book. Thanks are also due to the many members of The Center for Executive Coaching and The Center for Career Coaching who shared with me their own stories and ideas about creating a successful career. Nancy McAward and Pam Tharp kindly volunteered their time to make fantastic edits to the book, which I appreciate deeply. Eternal thanks go to my wife Elena, a successful entrepreneur and author who simultaneously wrote a book while I wrote this one—except she wrote hers while holding our third child on her lap for much of the process. Finally, I want to acknowledge my children Noah, Seth, and Willow. They will face greater challenges and opportunities in their careers than I ever did, and I wish them satisfaction, joy, peace, and success.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?d51e65d8